import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipeUtilModule } from '../../modules/pipes/pipe-util/pipe-util.module';
import { DeleteModule } from '../../common/components/delete/delete.module';
import { AssetLibraryModule } from '../asset-library/asset-library.module';
import { SkuIdsComponent } from './sku-ids.component';
import { SkuIdInfoComponent } from './sku-id-info/sku-id-info.component';
import { CreateSkuIdInfoComponent } from './create-sku-id-info/create-sku-id-info.component';
import { UploadSkuCsvComponent } from './upload-sku-csv/upload-sku-csv.component';
import { CompareSkuIdsComponent } from './compare-sku-ids/compare-sku-ids.component';


@NgModule({
  declarations: [SkuIdsComponent, SkuIdInfoComponent, CreateSkuIdInfoComponent, UploadSkuCsvComponent, CompareSkuIdsComponent],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    PipeUtilModule,
    AssetLibraryModule,
    DeleteModule
  ]
})
export class SkuIdsModule { }
